import React, { Fragment } from "react";
import EditItemDetails from "../../../Common/Components/EditItemDetails";

function Edit() {
  return (
    <Fragment>
      <EditItemDetails />
    </Fragment>
  );
}

export default Edit;
